//import config from 'config';
//import {userService} from "./user.service";
//import {authHeader} from '../helpers';

export const apiService = {
    track,
    processQuery
};


async function fetcher(url, requestOptions) {

        return fetch(url, requestOptions)
            .then(async function (response) {
                if (response.ok) {
                    let text = await response.text();
                    const data = text && JSON.parse(text);
                    return data;
                } else {
                    if (response.status === 401) {

                        // auto logout if 401 response returned from api
                        //userService.logout();
                        window.location.reload(true);
                        return null;

                    }else if(response.status === 400 || response.status === 500){
                        let text = await response.text();
                        const data = text && JSON.parse(text);
                        return data;
                    } else {
                        let text = await response.text();
                        let data = null;
                        if (text) {
                            data = text && JSON.parse(text);
                        }
                        const error = (data && data.message) || response.statusText;
                        return null;
                        //return Promise.reject(error);
                    }
                }
            })

            .catch(error => {
                console.log(error);
                return Promise.reject(error);
            })



}

function track(trackingNrArr, carrier, direction) {

    //const header = authHeader();
    //process.env.NEXT_PUBLIC_APIURL+
    try{

        console.log(process.env)
        let url = new URL(process.env.REACT_APP_APIURL+`/p/v1/track/query`);
        const requestOptions = {
            method: 'get',
            /*headers: {
                'Content-Type': 'application/json',
                'x-access-token': header["x-access-token"]
            },*/

        };


        var params = {
            tn: trackingNrArr.join(','),
        };
        if(carrier!=null){
            params.carrier=carrier
        }
        if(direction!=null){
            params.direction=direction
        }
        url.search = new URLSearchParams(params);
        return fetcher(url, requestOptions);
    }catch(err){
        console.log(err);
    }


}

function processQuery(trackingNrArr) {

    //const header = authHeader();
    var url = new URL(process.env.REACT_APP_APIURL+`/p/v1/track/process`);
    const requestOptions = {
        method: 'get',
        /*headers: {
            'Content-Type': 'application/json',
            'x-access-token': header["x-access-token"]
        },*/

    };
    var params = {
        tn: trackingNrArr.join(','),
    };

    url.search = new URLSearchParams(params);
    return fetcher(url, requestOptions);

}


